import { store } from "../store/store.js";

let preloaderEl = null;

function getPreloader() {
  if (!preloaderEl) {
    preloaderEl = document.getElementById("preloader");
  }
  return preloaderEl;
}

export function showPreloader() {
  const el = getPreloader();
  if (!el) return;

  el.style.display = "flex";
  el.style.opacity = "1";
  el.style.pointerEvents = "all";
}

export function hidde_preloader() {
  const el = getPreloader();
  if (!el) return;

  el.style.transition = "opacity 0.3s ease";
  el.style.opacity = "0";
  el.style.pointerEvents = "none";

  setTimeout(() => {
    el.style.display = "none";
    el.style.opacity = "1";
  }, 300);
}